<template>
  <section :key="swiperKey" class="home-banner">
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="(slide, index) in slides" :key="index">
        <img :src="slide.image" alt="banner">
      </swiper-slide>
      <!-- 分页器 -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </section>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import banner1 from '@/assets/images/banner-1.jpg'
import banner2 from '@/assets/images/banner-2.jpg'
import banner3 from '@/assets/images/banner-3.jpg'

import banner1en from '@/assets/images/banner-1-en.png'
import banner2en from '@/assets/images/banner-2-en.png'
import banner3en from '@/assets/images/banner-3-en.png'

import banner1Mobile from '@/assets/images/banner-1-mobile.png'
import banner2Mobile from '@/assets/images/banner-2-mobile.png'
import banner3Mobile from '@/assets/images/banner-3-mobile.png'

import banner1enMobile from '@/assets/images/banner-1-en-mobile.png'
import banner2enMobile from '@/assets/images/banner-2-en-mobile.png'
import banner3enMobile from '@/assets/images/banner-3-en-mobile.png'

export default {
  name: 'HomeBanner',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      width: 1280,
      swiperKey: 1,
      swiperOption: {
        // 配置选项
        pagination: {
          el: '.swiper-pagination'
        },
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper
    },
    slides () {
      const locale = this.$i18n.locale
      const isMobile = this.width <= 500
      return [
        { image: locale === 'zh' ? (isMobile ? banner1Mobile : banner1) : (isMobile ? banner1enMobile : banner1en) },
        { image: locale === 'zh' ? (isMobile ? banner2Mobile : banner2) : (isMobile ? banner2enMobile : banner2en) },
        { image: locale === 'zh' ? (isMobile ? banner3Mobile : banner3) : (isMobile ? banner3enMobile : banner3en) },
      ]
    },
  },
  mounted() {
    // 现在你可以使用 this.swiper 来访问 swiper 实例
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(0, 1000, false)
    this.width = window.innerWidth

    this.$nextTick(() => {
      this.swiperKey++
    })
  }
}
</script>

<style lang="scss">
.home-banner {
  width: 100%;
  padding-top: 74px;
}

.swiper-container {
  height: 620px;

  .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper-pagination-bullets {
    .swiper-pagination-bullet {
      width: 60px;
      height: 4px;
      background: #FFFFFF80;
      backdrop-filter: blur(17.600000381469727px);
      border-radius: 2px;

      &.swiper-pagination-bullet-active {
        background: linear-gradient(90deg, #2F55D4 0%, #54A5FD 100%);
      }
    }
  }

  @media screen and (max-width: 500px) {
    height: 207px;
  }
}
</style>